import React, {useState} from 'react'

export default function TextForm(props) {
  const handleUpClick = ()=> {
    //console.log("Uppercase was clicked" + text);
    let newText = text.toUpperCase();
    setText(newText)
    props.showAlert("converted to uppercase!", "success");
  }
    const handleLoClick = ()=> {
      //console.log("Lowercase was clicked" + text);
      let newText = text.toLowerCase();
        setText(newText)
        props.showAlert("converted to lowercase!", "success");
       
  }

  const handleClearClick = ()=> {
    //console.log("Uppercase was clicked" + text);
    let newText = '';
    setText(newText)
    props.showAlert("Text Cleared!", "success");
    
  }
  const handleOnChange = (event)=>{
    //console.log("On change");
    setText(event.target.value);
   
  }

  const handleCopy = () => {
    var text = document.getElementById("myBox")
    text.select();
    text.setSelectionRange(0, 9999);
    navigator.clipboard.writeText(text.value);
    props.showAlert("Copied to Clipboard!", "sucess");

  }

  const handleExtraSpaces = () =>{
    let newText = text.split(/[ ]+/);
    setText(newText.join(" "));
    props.showAlert("Extra spaces removed!", "success");
  }

  const [text, setText] = useState('Enter text here');
  // setText("new text");
  return (
    <>
    <div className="container" style={{color: props.mode==='light'?'#042743':'white'}}>
<div className="my-3">
      <h1>{props.heading}</h1>
      <textarea className="form-control" value={text} onChange={handleOnChange} style={{backgroundColor: props.mode==='light'?'white':'gray', color: props.mode==='light'?'#042743':'white'}} id="myBox" rows="8"></textarea>
</div>
<button className="btn btn-primary mx-1" onClick={handleUpClick}>Convert to UpperCase</button>
<button className="btn btn-primary mx-1" onClick={handleLoClick}>Convert to LowerCase</button>
<button className="btn btn-primary mx-1" onClick={handleClearClick}>Clear Text</button>
<button className="btn btn-primary mx-1" onClick={handleCopy}>Copy Text</button>
<button className="btn btn-primary mx-1" onClick={handleExtraSpaces}>Remove Extra Spaces</button>
    </div>
    <div className="container my-3" style={{color: props.mode==='light'?'#042743':'white'}}>
      <h2>Your text summary</h2>
      <p>{text.split(" ").length} words and {text.length} characters</p>
      <p>{0.008 * text.split(" ").length} Minutes read</p>
      <h2>Preview</h2>
      <p>{text.length>0?text: "Enter something in the textbox above to preview it here"}</p>
    </div>
    </>
  )
}
